import { Component } from '@angular/core';


@Component({
  selector: 'app-removal',
  templateUrl: './removal.component.html',
  styleUrls: ['./removal.component.sass']
})
export class RemovalComponent {


  data: any[] = [
    {
      title: 'Faça seu login.',
      description: 'Ao fazer seu login, você será redirecionado para home, clique no canto superior esquerdo nos 3 traços.',
    },
    {
      title: 'Após abrir o menu, role o cursor para baixo.',
      description: 'Após localizar “Privacidade” dê um clique.',
    },
    {
      title: 'Após isso, irá abrir as opções de “Privacidade”, logo abaixo poderá ver o botão de “solicitar remoção”',
      description: 'Para iniciar seu processo de remoção de conta, basta clicar neste botão:',
    },
    {
      title: 'Após clicar em “solicitar remoção”, aparecerá um pop-up, com as regras de remoção de conta de forma detalhada.',
      description: 'Após estar ciente destas informações, basta clicar em “confirmar” para dar continuidade na exclusão da sua conta.',
    },
    {
      title: 'Para finalizar o processo de exclusão da sua conta, basta adicionar seu e-mail que consta em seu cadastro e clicar em “confirmar”',
      description: 'Lembrando que esse processo é irreversível, então pedimos que leia atentamente cada etapa.',
    },
  ];
  constructor() {

  }


}

